/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-19 09:50:12
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-13 22:20:32
 */

// const url = process.env.BASE_URL
import store from '@/store'
let config= {
  version: '1.0.0',
  ossDomain: process.env.VUE_APP_OSS_DOMAIN, // oss域名
  ossAppDir: 'xladmin', // oss目录z
  uniBaseURL: process.env.VUE_APP_UNI_BASEURL, // html5链接
  pageSize: 10, // 分页条数
  tokenTime: 60 * 60 * 1000,
  loginAppId: '3c9a1563796c401183c6a441f5b96e1b',
  verificateAppId: 'fcc3fd8ddfb14cd68c54c0cc34f63bd6',
  // 多域名静态资源配置
  initDomain: {
    'default': {
      ename: "kuaihuolong",
      title: "快活龙",
      domain: "trade.51xinlong.com",
      logo: "/static/images/default/logo.png",
      logoTop: "",
      logoLogin: "/static/images/default/logo.png",
      backgroundImg: "/static/images/default/banner.jpg",
      icoUrl: "/static/images/default/default.ico",
      siderLogo: "/static/images/default/siderLogo.png",
      appQR: "/static/images/default/QRCode.jpg",
      location: '杭州',
      appId: '888', //测试999，正式888 请勿随意更改
      settlmentlCustom: {
        companyIds: [148834054111420416],
        originName: '江西省顺捷信息技术服务有限公司',
        currentName: '芜湖创晖信息技术有限公司',
        paymentAccount: '34050167680800000599',
        bankOfDeposit: '中国建设银行股份有限公司芜湖弋江支行',
        taxRate: '6',
        placeholder: '***'
      }
    },
    'manage.test.51xinlong.com': {
      ename: "kuaihuolong-test",
      title: "快活龙",
      domain: "manage.test.51xinlong.com",
      logo: "/static/images/khl-test/logo.png",
      logoTop: "",
      logoLogin: "/static/images/khl-test/logo.png",
      backgroundImg: "/static/images/khl-test/banner.jpg",
      icoUrl: "/static/images/khl-test/default.ico",
      siderLogo: "/static/images/khl-test/siderLogo.png",
      appQR: "/static/images/khl-test/QRCode.jpg",
      location: '杭州',
      appId: '999',
      settlmentlCustom: {
        companyIds: [1],
        originName: '*****服务公司',
        currentName: '芜湖创晖信息技术有限公司',
        paymentAccount: '34050167680800000599',
        bankOfDeposit: '中国建设银行股份有限公司芜湖弋江支行',
        taxRate: '6',
        placeholder: '***'
      }
    },
	'operation-xspt.kuaihuolong.cn': {
      ename: "xsbcszh",
      title: "演示运营中台",
      domain: "operation-xspt.kuaihuolong.cn",
      logo: "/static/images/default/logo.png",
      logoTop: "",
      logoLogin: "/static/images/default/logo.png",
      backgroundImg: "/static/images/default/banner.jpg",
      icoUrl: "/static/images/default/default.ico",
      siderLogo: "/static/images/default/siderLogo.png",
	},
    'operation-jspt.kuaihuolong.cn': {
      ename: "jsbcszh",
      title: "技术部测试系统",
      domain: "operation-jspt.kuaihuolong.cn",
      logo: "/static/images/default/logo.png",
      logoTop: "",
      logoLogin: "/static/images/default/logo.png",
      backgroundImg: "/static/images/default/banner.jpg",
      icoUrl: "/static/images/default/default.ico",
      siderLogo: "/static/images/default/siderLogo.png",
    },
	
    'kst-opr.kuaihuolong.cn': {
      ename: "yunyingzhongtai",
      title: "演示中台",
      domain: "kst-opr.kuaihuolong.cn",
      logo: "/static/images/nologo/logo.png",
      logoTop: "",
      logoLogin: "/static/images/nologo/logo.png",
      backgroundImg: "/static/images/nologo/banner.jpg",
      icoUrl: "/static/images/nologo/default.ico",
      siderLogo: "/static/images/nologo/siderLogo.png"
    },
    'www.xsb001.com': {
      ename: "xinshuibao",
      title: "薪税宝",
      domain: "www.xsb001.com",
      logo: "/static/images/xinshuibao/logo.png",
      logoTop: "/static/images/xinshuibao/logo-top.png",
      logoLogin: "/static/images/xinshuibao/logo.png",
      backgroundImg: "/static/images/xinshuibao/banner.jpg",
      icoUrl: "/static/images/xinshuibao/default.ico",
      siderLogo: "/static/images/xinshuibao/siderLogo.png"
    },
    'test.xsb001.com': {
      ename: "xinshuibao",
      title: "薪税宝",
      domain: "test.xsb001.com",
      logo: "/static/images/xinshuibao/logo.png",
      logoTop: "/static/images/xinshuibao/logo-top.png",
      logoLogin: "/static/images/xinshuibao/logo.png",
      backgroundImg: "/static/images/xinshuibao/banner.jpg",
      icoUrl: "/static/images/xinshuibao/default.ico",
      siderLogo: "/static/images/xinshuibao/siderLogo.png"
    },
    'www.hzdongxin.cn': {
      ename: "dongxin",
      title: "东薪网络",
      domain: "www.hzdongxin.cn",
      logo: "/static/images/dongxinwangluo/logo.png",
      logoTop: "/static/images/dongxinwangluo/logo-top.png",
      logoLogin: "/static/images/dongxinwangluo/logo.png",
      backgroundImg: "/static/images/dongxinwangluo/banner.jpg",
      icoUrl: "/static/images/dongxinwangluo/default.ico",
      siderLogo: "/static/images/dongxinwangluo/siderLogo.png"
    },
    'test.hzdongxin.cn': {
      ename: "dongxin",
      title: "东薪网络",
      domain: "test.hzdongxin.cn",
      logo: "/static/images/dongxinwangluo/logo.png",
      logoTop: "/static/images/dongxinwangluo/logo-top.png",
      logoLogin: "/static/images/dongxinwangluo/logo.png",
      backgroundImg: "/static/images/dongxinwangluo/banner.jpg",
      icoUrl: "/static/images/dongxinwangluo/default.ico",
      siderLogo: "/static/images/dongxinwangluo/siderLogo.png"
    },
    'khl-dongxin.51xinlong.com': {
      ename: "dongxin",
      title: "东薪网络",
      domain: "khl-dongxin.51xinlong.com",
      logo: "/static/images/dongxinwangluo/logo.png",
      logoTop: "/static/images/dongxinwangluo/logo-top.png",
      logoLogin: "/static/images/dongxinwangluo/logo.png",
      backgroundImg: "/static/images/dongxinwangluo/banner.jpg",
      icoUrl: "/static/images/dongxinwangluo/default.ico",
      siderLogo: "/static/images/dongxinwangluo/siderLogo.png"
    },
    'kst-dongxin.51xinlong.com': {
      ename: "dongxin",
      title: "东薪网络",
      domain: "kst-dongxin.51xinlong.com",
      logo: "/static/images/dongxinwangluo/logo.png",
      logoTop: "/static/images/dongxinwangluo/logo-top.png",
      logoLogin: "/static/images/dongxinwangluo/logo.png",
      backgroundImg: "/static/images/dongxinwangluo/banner.jpg",
      icoUrl: "/static/images/dongxinwangluo/default.ico",
      siderLogo: "/static/images/dongxinwangluo/siderLogo.png"
    },
    'xgc.gzwjcj.com': {
      ename: "xingongchang",
      title: "薪工场",
      domain: "xgc.gzwjcj.com",
      logo: "/static/images/xingongchang/logo.png",
      logoTop: "/static/images/xingongchang/logo-top.png",
      logoLogin: "/static/images/xingongchang/logo.png",
      backgroundImg: "/static/images/xingongchang/banner.jpg",
      icoUrl: "/static/images/xingongchang/default.ico",
      siderLogo: "/static/images/xingongchang/siderLogo.png",
      location: '广州',
      appId: '10001',
    },
    'kst-haobo.51xinlong.com': {
      ename: "haoborenli",
      title: "皓博人力",
      domain: "kst-haobo.51xinlong.com",
      logo: "/static/images/haoborenli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/haoborenli/logo.png",
      backgroundImg: "/static/images/haoborenli/banner.jpg",
      icoUrl: "/static/images/haoborenli/default.ico",
      siderLogo: "/static/images/haoborenli/siderLogo.png"
    },
    'khl-haobo.51xinlong.com': {
      ename: "haoborenli",
      title: "皓博人力",
      domain: "khl-haobo.51xinlong.com",
      logo: "/static/images/haoborenli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/haoborenli/logo.png",
      backgroundImg: "/static/images/haoborenli/banner.jpg",
      icoUrl: "/static/images/haoborenli/default.ico",
      siderLogo: "/static/images/haoborenli/siderLogo.png"
    },
    'xin.hzqfyx.com': {
      ename: "hzqfyx",
      title: "企服优选",
      domain: "xin.hzqfyx.com",
      logo: "/static/images/qifuyouxuan/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qifuyouxuan/logo.png",
      backgroundImg: "/static/images/qifuyouxuan/banner.jpg",
      icoUrl: "/static/images/qifuyouxuan/default.ico",
      siderLogo: "/static/images/qifuyouxuan/siderLogo.png"
    },
    // 'khl-whch.51xinlong.com': {
    //   ename: "whch",
    //   title: "芜湖创晖",
    //   domain: "khl-whch.51xinlong.com",
    //   logo: "/static/images/whch/logo.png",
    //   logoTop: "",
    //   logoLogin: "/static/images/default/logo.png",
    //   backgroundImg: "/static/images/default/banner.jpg",
    //   icoUrl: "/static/images/default/default.ico",
    //   siderLogo: "/static/images/default/siderLogo.png"
    // },
    'khl-whch.51xinlong.com': {
      ename: "whch",
      title: "芜湖创晖",
      domain: "khl-whch.51xinlong.com",
      logo: "/static/images/whch/logo.jpg",
      logoTop: "",
      logoLogin: "/static/images/whch/logo.jpg",
      backgroundImg: "/static/images/whch/banner.jpg",
      icoUrl: "/static/images/whch/defualt.ico",
      siderLogo: "/static/images/whch/siderLogo.jpg"
    },
    'ry.hzqfyx.com': {
      ename: "hzqfyx",
      title: "睿赢企服",
      domain: "ry.hzqfyx.com",
      logo: "/static/images/ruiying/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ruiying/logo.png",
      backgroundImg: "/static/images/ruiying/banner.jpg",
      icoUrl: "/static/images/ruiying/default.ico",
      siderLogo: "/static/images/ruiying/siderLogo.png"
    },
    'khl-kdw.51xinlong.com': {
      ename: "tyqf",
      title: "腾云企服",
      domain: "khl-kdw.51xinlong.com",
      logo: "/static/images/kdw/logo.png",
      logoTop: "",
      logoLogin: "/static/images/kdw/logo.png",
      backgroundImg: "/static/images/kdw/banner.jpg",
      icoUrl: "/static/images/kdw/default.ico",
      siderLogo: "/static/images/kdw/siderLogo.png"
    },
    'khl-ym.51xinlong.com': {
      ename: "yunmi",
      title: "云米",
      domain: "khl-ym.51xinlong.com",
      logo: "/static/images/ym/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ym/logo.png",
      backgroundImg: "/static/images/ym/banner.jpg",
      icoUrl: "/static/images/ym/default.ico",
      siderLogo: "/static/images/ym/siderLogo.png"
    },
    'khl-ml.51xinlong.com': {
      ename: "ml",
      title: "木链",
      domain: "khl-ml.51xinlong.com",
      logo: "/static/images/ml/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ml/logo.png",
      backgroundImg: "/static/images/ml/banner.jpg",
      icoUrl: "/static/images/ml/default.ico",
      siderLogo: "/static/images/ml/siderLogo.png"
    },
    'khl-szy.51xinlong.com': {
      ename: "shangzhuangyuan",
      title: "商状元",
      domain: "khl-szy.51xinlong.com/",
      logo: "/static/images/szy/logo.png",
      logoTop: "",
      logoLogin: "/static/images/szy/logo.png",
      backgroundImg: "/static/images/szy/banner.jpg",
      icoUrl: "/static/images/szy/default.ico",
      siderLogo: "/static/images/szy/siderLogo.png"
    },
    'khl-jc.51xinlong.com': {
      ename: "jici",
      title: "济慈",
      domain: "khl-jc.51xinlong.com",
      logo: "/static/images/jc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jc/logo.png",
      backgroundImg: "/static/images/jc/banner.jpg",
      icoUrl: "/static/images/jc/default.ico",
      siderLogo: "/static/images/jc/siderLogo.png"
    },
    'khl-yxcs.51xinlong.com': {
      ename: "jici",
      title: "易晓财税",
      domain: "khl-yxcs.51xinlong.com",
      logo: "/static/images/yxcs/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yxcs/logo.png",
      backgroundImg: "/static/images/yxcs/banner.jpg",
      icoUrl: "/static/images/yxcs/default.ico",
      siderLogo: "/static/images/yxcs/siderLogo.png"
    },
    'khl-yx.51xinlong.com': {
      ename: "yaxuan",
      title: "雅轩文化传媒",
      domain: "khl-yx.51xinlong.com",
      logo: "/static/images/yx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yx/logo.png",
      backgroundImg: "/static/images/yx/banner.jpg",
      icoUrl: "/static/images/yx/default.ico",
      siderLogo: "/static/images/yx/siderLogo.png"
    },
    'khl-sxyl.51xinlong.com': {
      ename: "shengxuanyule",
      title: "笙轩娱乐",
      domain: "khl-sxyl.51xinlong.com",
      logo: "/static/images/sxyl/logo.png",
      logoTop: "",
      logoLogin: "/static/images/sxyl/logo.png",
      backgroundImg: "/static/images/sxyl/banner.jpg",
      icoUrl: "/static/images/sxyl/default.ico",
      siderLogo: "/static/images/sxyl/siderLogo.png"
    },
    'xlw.lanjingsk.com': {
      ename: "dayu",
      title: "大鱼致税",
      domain: "xlw.lanjingsk.com",
      logo: "/static/images/dy/logo.png",
      logoTop: "",
      logoLogin: "/static/images/dy/logo.png",
      backgroundImg: "/static/images/dy/banner.jpg",
      icoUrl: "/static/images/dy/default1.ico",
      siderLogo: "/static/images/dy/siderLogo.png"
    },
    'hzchs.kaizuo.net': {
      ename: "anjicaihe",
      title: "安吉财合",
      domain: "hzchs.kaizuo.net",
      logo: "/static/images/ajch/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ajch/logo.png",
      backgroundImg: "/static/images/ajch/banner.jpg",
      icoUrl: "/static/images/ajch/default1.ico",
      siderLogo: "/static/images/ajch/siderLogo.png"
    },
    'khl-xlc.51xinlong.com': {
      ename: "xinlingcai",
      title: "薪灵才",
      domain: "khl-xlc.51xinlong.com",
      logo: "/static/images/xlc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xlc/logo.png",
      backgroundImg: "/static/images/xlc/banner.jpg",
      icoUrl: "/static/images/xlc/default2.ico",
      siderLogo: "/static/images/xlc/siderLogo.png"
    },
    'saas.fzzchr.com': {
      ename: "shizhicai",
      title: "智才",
      domain: "saas.fzzchr.com",
      logo: "/static/images/szc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/szc/logo.png",
      backgroundImg: "/static/images/szc/banner.jpg",
      icoUrl: "/static/images/szc/default1.ico",
      siderLogo: "/static/images/szc/siderLogo.png"
    },
    'khl-oem.51xinlong.com': {
      ename: "nologo",
      title: "",
      domain: "khl-oem.51xinlong.com",
      logo: "/static/images/nologo/logo.png",
      logoTop: "",
      logoLogin: "/static/images/nologo/logo.png",
      backgroundImg: "/static/images/nologo/banner.jpg",
      icoUrl: "/static/images/nologo/default.ico",
      siderLogo: "/static/images/nologo/siderLogo.png"
    },
    'kst-oem.51xinlong.com': {
      ename: "nologo",
      title: "",
      domain: "kst-oem.51xinlong.com",
      logo: "/static/images/nologo/logo.png",
      logoTop: "",
      logoLogin: "/static/images/nologo/logo.png",
      backgroundImg: "/static/images/nologo/banner.jpg",
      icoUrl: "/static/images/nologo/default.ico",
      siderLogo: "/static/images/nologo/siderLogo.png"
    },
    'khl-ys.51xinlong.com': {
      ename: "yunshang",
      title: "云尚",
      domain: "khl-ys.51xinlong.com",
      logo: "/static/images/ys/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ys/logo.png",
      backgroundImg: "/static/images/ys/banner.jpg",
      icoUrl: "/static/images/ys/default.ico",
      siderLogo: "/static/images/ys/siderLogo.png"
    },
    'khl-cc.51xinlong.com': {
      ename: "chuncheng",
      title: "春城科技",
      domain: "khl-cc.51xinlong.com",
      logo: "/static/images/cc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/cc/logo.png",
      backgroundImg: "/static/images/cc/banner.jpg",
      icoUrl: "/static/images/cc/default.ico",
      siderLogo: "/static/images/cc/siderLogo.png"
    },
    'khl-xcwh.51xinlong.com': {
      ename: "xinchuangwenhua",
      title: "星创文化",
      domain: "khl-xcwh.51xinlong.com",
      logo: "/static/images/xcwh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xcwh/logo.png",
      backgroundImg: "/static/images/xcwh/banner.jpg",
      icoUrl: "/static/images/xcwh/default.ico",
      siderLogo: "/static/images/xcwh/siderLogo.png"
    },
    'khl-qdh.51xinlong.com': {
      ename: "xinchuangwenhua",
      title: "云点工",
      domain: "khl-qdh.51xinlong.com",
      logo: "/static/images/qdh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qdh/logo.png",
      backgroundImg: "/static/images/qdh/banner.jpg",
      icoUrl: "/static/images/qdh/default.ico",
      siderLogo: "/static/images/qdh/siderLogo.png"
    },
    'saas.sosoboss.com': {
      ename: "xinchuangwenhua",
      title: "云点工",
      domain: "saas.sosoboss.com",
      logo: "/static/images/qdh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qdh/logo.png",
      backgroundImg: "/static/images/qdh/banner.jpg",
      icoUrl: "/static/images/qdh/default.ico",
      siderLogo: "/static/images/qdh/siderLogo.png"
    },
    'khl-zqzx.51xinlong.com': {
      ename: "zhaoqingzhongxin",
      title: "肇庆众信",
      domain: "khl-zqzx.51xinlong.com",
      logo: "/static/images/zqzx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zqzx/logo.png",
      backgroundImg: "/static/images/zqzx/banner.jpg",
      icoUrl: "/static/images/zqzx/default1.ico",
      siderLogo: "/static/images/zqzx/siderLogo.png"
    },
    'saas.gaolanshw.com': {
      ename: "gaolanzixun",
      title: "高蓝咨询",
      domain: "saas.gaolanshw.com",
      logo: "/static/images/glzx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/glzx/logo.png",
      backgroundImg: "/static/images/glzx/banner.jpg",
      icoUrl: "/static/images/glzx/default1.ico",
      siderLogo: "/static/images/glzx/siderLogo.png"
    },
    'www.whxrk.cn': {
      ename: "xiangrkui",
      title: "向日葵",
      domain: "www.whxrk.cn",
      logo: "/static/images/xrk/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xrk/logo.png",
      backgroundImg: "/static/images/xrk/banner.jpg",
      icoUrl: "/static/images/xrk/default.ico",
      siderLogo: "/static/images/xrk/siderLogo.png"
    },
    'khl-yqxf.51xinlong.com': {
      ename: "yiqixinfu",
      title: "亿企新服",
      domain: "khl-yqxf.51xinlong.com",
      logo: "/static/images/yqxf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yqxf/logo.png",
      backgroundImg: "/static/images/yqxf/banner.jpg",
      icoUrl: "/static/images/yqxf/default.ico",
      siderLogo: "/static/images/yqxf/siderLogo.png"
    },
    'khl-sqq.51xinlong.com': {
      ename: "shuiqingqing",
      title: "税轻轻",
      domain: "khl-sqq.51xinlong.com",
      logo: "/static/images/sqq/logo.png",
      logoTop: "",
      logoLogin: "/static/images/sqq/logo.png",
      backgroundImg: "/static/images/sqq/banner.jpg",
      icoUrl: "/static/images/sqq/default.ico",
      siderLogo: "/static/images/sqq/siderLogo.png"
    },
    'operation.1shuichou.com': {
      ename: "Eshuichou",
      title: "E税筹",
      domain: "operation.1shuichou.com",
      logo: "/static/images/esc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/esc/logo.png",
      backgroundImg: "/static/images/esc/banner.jpg",
      icoUrl: "/static/images/esc/default.ico",
      siderLogo: "/static/images/esc/siderLogo.png"
    },
    'partner.xiyk.cn': {
      ename: "xiyouke",
      title: "僖游客",
      domain: "partner.xiyk.cn",
      logo: "/static/images/xyk/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xyk/logo.png",
      backgroundImg: "/static/images/xyk/banner.jpg",
      icoUrl: "/static/images/xyk/default.ico",
      siderLogo: "/static/images/xyk/siderLogo.png"
    },
    'a.yiruitec.top': {
      ename: "yunshangbao",
      title: "云商宝",
      domain: "a.yiruitec.top",
      logo: "/static/images/ysb/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ysb/logo.png",
      backgroundImg: "/static/images/ysb/banner.jpg",
      icoUrl: "/static/images/ysb/default.ico",
      siderLogo: "/static/images/ysb/siderLogo.png"
    },
    'cde.nashizhongbao.com': {
      ename: "nashiwangluo",
      title: "纳士网络",
      domain: "cde.nashizhongbao.com",
      logo: "/static/images/nswl/logo.png",
      logoTop: "",
      logoLogin: "/static/images/nswl/logo.png",
      backgroundImg: "/static/images/nswl/banner.jpg",
      icoUrl: "/static/images/nswl/default.ico",
      siderLogo: "/static/images/nswl/siderLogo.png"
    },
    'www.ssdcsy.cn': {
      ename: "caishuiyi",
      title: "财税益",
      domain: "www.ssdcsy.cn",
      logo: "/static/images/caishuiyi/logo.png",
      logoTop: "",
      logoLogin: "/static/images/caishuiyi/logo.png",
      backgroundImg: "/static/images/caishuiyi/banner.jpg",
      icoUrl: "/static/images/caishuiyi/default.ico",
      siderLogo: "/static/images/caishuiyi/siderLogo.png"
    },
    'opr-jjkj.51xinlong.com': {
      ename: "jjkj",
      title: "济嘉科技",
      domain: "opr-jjkj.51xinlong.com",
      logo: "/static/images/jj/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jj/logo.png",
      backgroundImg: "/static/images/jj/banner.jpg",
      icoUrl: "/static/images/jj/default.ico",
      siderLogo: "/static/images/jj/siderLogo.png"
    },
    'opr-chkj.51xinlong.com': {
      ename: "chkj",
      title: "沧海科技",
      domain: "opr-chkj.51xinlong.com",
      logo: "/static/images/canghaikeji/logo.png",
      logoTop: "",
      logoLogin: "/static/images/canghaikeji/logo.png",
      backgroundImg: "/static/images/canghaikeji/banner.jpg",
      icoUrl: "/static/images/canghaikeji/default.ico",
      siderLogo: "/static/images/canghaikeji/siderLogo.png"
    },
    'opr-ycc.51xinlong.com': {
      ename: "ychengc",
      title: "云诚才",
      domain: "opr-ycc.51xinlong.com",
      logo: "/static/images/operation-ycc/logo.png",
      logoTop: "",
      logoLogin: "/static/images/operation-ycc/logo.png",
      backgroundImg: "/static/images/operation-ycc/banner.jpg",
      icoUrl: "/static/images/operation-ycc/default.ico",
      siderLogo: "/static/images/operation-ycc/siderLogo.png"
    },
    'opr-dcx.51xinlong.com': {
      ename: "dcaix",
      title: "德财鑫",
      domain: "opr-dcx.51xinlong.com",
      logo: "/static/images/decaixing/logo.png",
      logoTop: "",
      logoLogin: "/static/images/decaixing/logo.png",
      backgroundImg: "/static/images/decaixing/banner.jpg",
      icoUrl: "/static/images/decaixing/default.ico",
      siderLogo: "/static/images/decaixing/siderLogo.png"
    },
    'opr.szbchr.cn': {
      ename: "bc",
      title: "博才",
      domain: "opr.szbchr.cn",
      logo: "/static/images/bocai/logo.png",
      logoTop: "",
      logoLogin: "/static/images/bocai/logo.png",
      backgroundImg: "/static/images/bocai/banner.jpg",
      icoUrl: "/static/images/bocai/default.ico",
      siderLogo: "/static/images/bocai/siderLogo.png"
    },
    'opr.ylg123.cn': {
      ename: "xkkj",
      title: "管理中台",
      domain: "opr.ylg123.cn",
      logo: "/static/images/zxbq/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zxbq/logo.png",
      backgroundImg: "/static/images/zxbq/banner.jpg",
      icoUrl: "/static/images/zxb/default.ico",
      siderLogo: "/static/images/zxbq/siderLogo.png"
    },
    'opr-cny.51xinlong.com': {
      ename: "chengnayun",
      title: "诚纳云",
      domain: "opr-cny.51xinlong.com",
      logo: "/static/images/cny/logo.png",
      logoTop: "",
      logoLogin: "/static/images/cny/logo.png",
      backgroundImg: "/static/images/cny/banner.jpg",
      icoUrl: "/static/images/cny/default.ico",
      siderLogo: "/static/images/cny/siderLogo.png"
    },
    'def.sensinss.com': {
      ename: "ss",
      title: "SENSIN申狮",
      domain: "def.sensinss.com",
      logo: "/static/images/senshi/logo.png",
      logoTop: "",
      logoLogin: "/static/images/senshi/logo.png",
      backgroundImg: "/static/images/senshi/banner.jpg",
      icoUrl: "/static/images/senshi/default.ico",
      siderLogo: "/static/images/senshi/siderLogo.png"
    },
    'opr-sry.51xinlong.com': {
      ename: "shangrenyuan",
      title: "上人院",
      domain: "opr-sry.51xinlong.com",
      logo: "/static/images/shangrenyuan/logo.png",
      logoTop: "",
      logoLogin: "/static/images/shangrenyuan/logo.png",
      backgroundImg: "/static/images/shangrenyuan/banner.jpg",
      icoUrl: "/static/images/shangrenyuan/default.ico",
      siderLogo: "/static/images/shangrenyuan/siderLogo.png"
    },
    'opr-xnf.xinnafu.com': {
      ename: "oprxinnafu",
      title: "鑫纳服",
      domain: "opr-xnf.xinnafu.com",
      logo: "/static/images/xinnafu/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinnafu/logo.png",
      backgroundImg: "/static/images/xinnafu/banner.jpg",
      icoUrl: "/static/images/xinnafu/default.ico",
      siderLogo: "/static/images/xinnafu/siderLogo.png"
    },
    'opr-zhl.51xinlong.com': {
      ename: "oprzhl",
      title: "众恒力",
      domain: "opr-zhl.51xinlong.com",
      logo: "/static/images/zhonghengli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhonghengli/logo.png",
      backgroundImg: "/static/images/xinnafu/banner.jpg",
      icoUrl: "/static/images/zhonghengli/default.ico",
      siderLogo: "/static/images/zhonghengli/siderLogo.png"
    },
    'opr-zj.51xinlong.com': {
      ename: "oprzhejia",
      title: "这佳集团",
      domain: "opr-zj.51xinlong.com",
      logo: "/static/images/zhejia/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhejia/logo.png",
      backgroundImg: "/static/images/zhejia/banner.jpg",
      icoUrl: "/static/images/zhejia/default.ico",
      siderLogo: "/static/images/zhejia/siderLogo.png"
    },
    'jd.91jindou.cn': {
      ename: "oprjindouyun",
      title: "金斗云",
      domain: "jd.91jindou.cn",
      logo: "/static/images/jindouyun/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jindouyun/logo.png",
      backgroundImg: "/static/images/jindouyun/banner.jpg",
      icoUrl: "/static/images/jindouyun/default.ico",
      siderLogo: "/static/images/jindouyun/siderLogo.png"
    },
    'opr-gbb.51xinlong.com': {
      ename: "gongbang",
      title: "工帮帮",
      domain: "opr-gbb.51xinlong.com",
      logo: "/static/images/gongbang/logo.png",
      logoTop: "",
      logoLogin: "/static/images/gongbang/logo.png",
      backgroundImg: "/static/images/gongbang/banner.jpg",
      icoUrl: "/static/images/gongbang/default.ico",
      siderLogo: "/static/images/gongbang/siderLogo.png"
    },
    'opr-qisb.51xinlong.com': {
      ename: "oprqishuibao",
      title: "企税宝",
      domain: "opr-qisb.51xinlong.com",
      logo: "/static/images/qishuibao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/qishuibao/logo.png",
      backgroundImg: "/static/images/qishuibao/banner.jpg",
      icoUrl: "/static/images/qishuibao/default.ico",
      siderLogo: "/static/images/qishuibao/siderLogo.png"
    },
    'opr-jyx.51xinlong.com': {
      ename: "oprjuyouxin",
      title: "聚优薪",
      domain: "opr-jyx.51xinlong.com",
      logo: "/static/images/juyouxin/logo.png",
      logoTop: "",
      logoLogin: "/static/images/juyouxin/logo.png",
      backgroundImg: "/static/images/juyouxin/banner.jpg",
      icoUrl: "/static/images/juyouxin/default.ico",
      siderLogo: "/static/images/juyouxin/siderLogo.png"
    },
    'opr-brrl.51xinlong.com': {
      ename: "oprborurenli",
      title: "博儒人力",
      domain: "opr-brrl.51xinlong.com",
      logo: "/static/images/borurenli/logo.png",
      logoTop: "",
      logoLogin: "/static/images/borurenli/logo.png",
      backgroundImg: "/static/images/borurenli/banner.jpg",
      icoUrl: "/static/images/borurenli/default.ico",
      siderLogo: "/static/images/borurenli/siderLogo.png"
    },
    'opr.lierjixin.com': {
      ename: "oprjixin",
      title: "积信",
      domain: "opr.lierjixin.com",
      logo: "/static/images/jixin/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jixin/logo.png",
      backgroundImg: "/static/images/jixin/banner.jpg",
      icoUrl: "/static/images/jixin/default.ico",
      siderLogo: "/static/images/jixin/siderLogo.png"
    },
    'opr-mfrl.51xinlong.com': {
      ename: "oprmifeng",
      title: "蜜蜂互联",
      domain: "opr-mfrl.51xinlong.com",
      logo: "/static/images/mifeng/logo.png",
      logoTop: "",
      logoLogin: "/static/images/mifeng/logo.png",
      backgroundImg: "/static/images/mifeng/banner.jpg",
      icoUrl: "/static/images/mifeng/default.ico",
      siderLogo: "/static/images/mifeng/siderLogo.png"
    },
    'operation.anshizixun.com': {
      ename: "opranshi",
      title: "安释科创研发众包平台",
      domain: "operation.anshizixun.com",
      logo: "/static/images/anshizixun/logo.png",
      logoTop: "",
      logoLogin: "/static/images/anshizixun/logo.png",
      backgroundImg: "/static/images/anshizixun/banner.jpg",
      icoUrl: "/static/images/anshizixun/default.ico",
      siderLogo: "/static/images/anshizixun/siderLogo.png"
    },
    '51xinlong.eboss007.com': {
      ename: "piaolian",
      title: "票联科技",
      domain: "51xinlong.eboss007.com",
      logo: "/static/images/piaolian/logo.png",
      logoTop: "",
      logoLogin: "/static/images/piaolian/logo.png",
      backgroundImg: "/static/images/anshizixun/banner.jpg",
      icoUrl: "/static/images/piaolian/default.ico",
      siderLogo: "/static/images/piaolian/siderLogo.png"
    },
    'opr-xr.51xinlong.com': {
      ename: "oprxinrong",
      title: "昕融",
      domain: "opr-xr.51xinlong.com",
      logo: "/static/images/xinrong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xinrong/logo.png",
      backgroundImg: "/static/images/xinrong/banner.jpg",
      icoUrl: "/static/images/xinrong/default.ico",
      siderLogo: "/static/images/xinrong/siderLogo.png"
    },
    'opr-xq.51xinlong.com': {
      ename: "oprxinrong",
      title: "手掌薪",
      domain: "opr-xq.51xinlong.com",
      logo: "/static/images/szx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/szx/logo.png",
      backgroundImg: "/static/images/szx/banner.jpg",
      icoUrl: "/static/images/szx/default.ico",
      siderLogo: "/static/images/szx/siderLogo.png"
    },
    'opr.catdo.cn': {
      ename: "oprbojin",
      title: "伯锦船舶科技",
      domain: "opr.catdo.cn",
      logo: "/static/images/bojin/logo.png",
      logoTop: "",
      logoLogin: "/static/images/bojin/logo.png",
      backgroundImg: "/static/images/bojin/banner.jpg",
      icoUrl: "/static/images/bojin/default.ico",
      siderLogo: "/static/images/bojin/siderLogo.png"
    },
    'opr-cdrl.51xinlong.com': {
      ename: "oprchuangda",
      title: "创达财税",
      domain: "opr-cdrl.51xinlong.com",
      logo: "/static/images/chuangda/logo.png",
      logoTop: "",
      logoLogin: "/static/images/chuangda/logo.png",
      backgroundImg: "/static/images/chuangda/banner.jpg",
      icoUrl: "/static/images/chuangda/default.ico",
      siderLogo: "/static/images/chuangda/siderLogo.png"
    },
    'opr-jyg.51xinlong.com': {
      ename: "oprjuyonggong",
      title: "聚用工网络",
      domain: "opr-jyg.51xinlong.com",
      logo: "/static/images/juyonggong/logo.png",
      logoTop: "",
      logoLogin: "/static/images/juyonggong/logo.png",
      backgroundImg: "/static/images/juyonggong/banner.jpg",
      icoUrl: "/static/images/juyonggong/default.ico",
      siderLogo: "/static/images/juyonggong/siderLogo.png"
    },
    'abc.yuntouck.com': {
      ename: "jxyt",
      title: "江西云投",
      domain: "abc.yuntouck.com",
      logo: "/static/images/jiangxiyuntou/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jiangxiyuntou/logo.png",
      backgroundImg: "/static/images/jiangxiyuntou/banner.jpg",
      icoUrl: "/static/images/jiangxiyuntou/default.ico",
      siderLogo: "/static/images/jiangxiyuntou/siderLogo.png"
    },
    'hc.changshenghuatai.com': {
      ename: "huataijituan",
      title: "华泰集团",
      domain: "hc.changshenghuatai.com",
      logo: "/static/images/huataitouzi/logo.png",
      logoTop: "",
      logoLogin: "/static/images/huataitouzi/logo.png",
      backgroundImg: "/static/images/huataitouzi/banner.jpg",
      icoUrl: "/static/images/huataitouzi/default.ico",
      siderLogo: "/static/images/huataitouzi/siderLogo.png"
    },
    'opr-sg.51xinlong.com': {
      ename: "shanggaooem",
      title: "尚高",
      domain: "opr-sg.51xinlong.com",
      logo: "/static/images/shanggao/logo.png",
      logoTop: "",
      logoLogin: "/static/images/shanggao/logo.png",
      backgroundImg: "/static/images/shanggao/banner.jpg",
      icoUrl: "/static/images/shanggao/default.ico",
      siderLogo: "/static/images/shanggao/siderLogo.png"
    },
    'opr-hjyc.51xinlong.com': {
      ename: "oprhuijuqifu",
      title: "汇聚企服",
      domain: "opr-hjyc.51xinlong.com",
      logo: "/static/images/huijuqifu/logo.png",
      logoTop: "",
      logoLogin: "/static/images/huijuqifu/logo.png",
      backgroundImg: "/static/images/huijuqifu/banner.jpg",
      icoUrl: "/static/images/huijuqifu/default.ico",
      siderLogo: "/static/images/huijuqifu/siderLogo.png"
    },
    'opr-cxkj.51xinlong.com': {
      ename: "oprxincai",
      title: "薪财科技",
      domain: "opr-cxkj.51xinlong.com",
      logo: "/static/images/xckj/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xckj/logo.png",
      backgroundImg: "/static/images/xckj/banner.jpg",
      icoUrl: "/static/images/xckj/default.ico",
      siderLogo: "/static/images/xckj/siderLogo.png"
    },
    'opr.xyg998.com': {
      ename: "oprxinyuangong",
      title: "薪员工",
      domain: "opr.xyg998.com",
      logo: "/static/images/xyg/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xyg/logo.png",
      backgroundImg: "/static/images/xyg/banner.jpg",
      icoUrl: "/static/images/xyg/default.ico",
      siderLogo: "/static/images/xyg/siderLogo.png"
    },
    'lhyg.lanlingcb.com': {
      ename: "oprlanlingchengbang",
      title: "蓝领城邦",
      domain: "lhyg.lanlingcb.com",
      logo: "/static/images/llcb/logo.png",
      logoTop: "",
      logoLogin: "/static/images/llcb/logo.png",
      backgroundImg: "/static/images/llcb/banner.jpg",
      icoUrl: "/static/images/llcb/default.ico",
      siderLogo: "/static/images/llcb/siderLogo.png"
    },
    'opr-zxzx.51xinlong.com': {
      ename: "oprzhongxin",
      title: "中鑫",
      domain: "opr-zxzx.51xinlong.com",
      logo: "/static/images/zx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zx/logo.png",
      backgroundImg: "/static/images/zx/banner.jpg",
      icoUrl: "/static/images/zx/default.ico",
      siderLogo: "/static/images/zx/siderLogo.png"
    },
    'opr-xlkj.51xinlong.com': {
      ename: "oprxinlingkeji",
      title: "薪灵科技",
      domain: "opr-xlkj.51xinlong.com",
      logo: "/static/images/xlkj/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xlkj/logo.png",
      backgroundImg: "/static/images/xlkj/banner.jpg",
      icoUrl: "/static/images/xlkj/default.ico",
      siderLogo: "/static/images/xlkj/siderLogo.png"
    },
    'opr.zchear.com': {
      ename: "oprzhichengqifu",
      title: "志成企服",
      domain: "opr.zchear.com",
      logo: "/static/images/zcqf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zcqf/logo.png",
      backgroundImg: "/static/images/zcqf/banner.jpg",
      icoUrl: "/static/images/zcqf/default.ico",
      siderLogo: "/static/images/zcqf/siderLogo.png"
    },
    'opr-yymk.51xinlong.com': {
      ename: "opryunyoumaike",
      title: "云优麦客",
      domain: "opr-yymk.51xinlong.com",
      logo: "/static/images/yymk/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yymk/logo.png",
      backgroundImg: "/static/images/yymk/banner.jpg",
      icoUrl: "/static/images/yymk/default.ico",
      siderLogo: "/static/images/yymk/siderLogo.png"
    },
    'opr-xsf.51xinlong.com': {
      ename: "oprxinshanfu",
      title: "薪闪付",
      domain: "opr-xsf.51xinlong.com",
      logo: "/static/images/xsf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xsf/logo.png",
      backgroundImg: "/static/images/xsf/banner.jpg",
      icoUrl: "/static/images/xsf/default.ico",
      siderLogo: "/static/images/xsf/siderLogo.png"
    },
    'opr.bthzrl.com': {
      ename: "oprfangxinfa",
      title: "放薪发",
      domain: "opr.bthzrl.com",
      logo: "/static/images/fxf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/fxf/logo.png",
      backgroundImg: "/static/images/fxf/banner.jpg",
      icoUrl: "/static/images/fxf/default.ico",
      siderLogo: "/static/images/fxf/siderLogo.png"
    },
    'opr-lqqf.51xinlong.com': {
      ename: "oprlianqiqifu",
      title: "联企企服",
      domain: "opr-lqqf.51xinlong.com",
      logo: "/static/images/lqqf/logo.png",
      logoTop: "",
      logoLogin: "/static/images/lqqf/logo.png",
      backgroundImg: "/static/images/lqqf/banner.jpg",
      icoUrl: "/static/images/lqqf/default.ico",
      siderLogo: "/static/images/lqqf/siderLogo.png"
    },
    'opr-ysh.51xinlong.com': {
      ename: "opryousuiyun",
      title: "优税云",
      domain: "opr-ysh.51xinlong.com",
      logo: "/static/images/ysh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/ysh/logo.png",
      backgroundImg: "/static/images/ysh/banner.jpg",
      icoUrl: "/static/images/ysh/default.ico",
      siderLogo: "/static/images/ysh/siderLogo.png"
    },
    'opr-shr.51xinlong.com': {
      ename: "oprsuihuirong",
      title: "穗惠荣",
      domain: "opr-shr.51xinlong.com",
      logo: "/static/images/shr/logo.png",
      logoTop: "",
      logoLogin: "/static/images/shr/logo.png",
      backgroundImg: "/static/images/shr/banner.jpg",
      icoUrl: "/static/images/shr/default.ico",
      siderLogo: "/static/images/shr/siderLogo.png"
    },
    'opr-xcx.51xinlong.com': {
      ename: "oprxinchangxiang",
      title: "薪畅向",
      domain: "opr-xcx.51xinlong.com",
      logo: "/static/images/xcx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xcx/logo.png",
      backgroundImg: "/static/images/xcx/banner.jpg",
      icoUrl: "/static/images/xcx/default.ico",
      siderLogo: "/static/images/xcx/siderLogo.png"
    },
    'opr.zezhehui.com': {
      ename: "oprzezhehui",
      title: "责哲惠",
      domain: "opr.zezhehui.com",
      logo: "/static/images/zzh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zzh/logo.png",
      backgroundImg: "/static/images/zzh/banner.jpg",
      icoUrl: "/static/images/zzh/default.ico",
      siderLogo: "/static/images/zzh/siderLogo.png"
    },
    'opr.zhongxiang888.com': {
      ename: "oprzhonghengqixu",
      title: "中亨企旭",
      domain: "opr.zhongxiang888.com",
      logo: "/static/images/zhqx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zhqx/logo.png",
      backgroundImg: "/static/images/zhqx/banner.jpg",
      icoUrl: "/static/images/zhqx/default.ico",
      siderLogo: "/static/images/zhqx/siderLogo.png"
    },
    'opr-ytrl.51xinlong.com': {
      ename: "opryintong",
      title: "银通人力",
      domain: "opr-ytrl.51xinlong.com",
      logo: "/static/images/yt/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yt/logo.png",
      backgroundImg: "/static/images/yt/banner.jpg",
      icoUrl: "/static/images/yt/default.ico",
      siderLogo: "/static/images/yt/siderLogo.png"
    },
    'iop.smefssc.com': {
      ename: "oprmixiaoen",
      title: "米小恩",
      domain: "iop.smefssc.com",
      logo: "/static/images/mxe/logo.png",
      logoTop: "",
      logoLogin: "/static/images/mxe/logo.png",
      backgroundImg: "/static/images/mxe/banner.jpg",
      icoUrl: "/static/images/mxe/default.ico",
      siderLogo: "/static/images/mxe/siderLogo.png"
    },
    'opr.all4onetech.com': {
      ename: "oprhangzhi",
      title: "行置科技",
      domain: "opr.all4onetech.com",
      logo: "/static/images/hangzhi/logo.png",
      logoTop: "",
      logoLogin: "/static/images/hangzhi/logo.png",
      backgroundImg: "/static/images/hangzhi/banner.jpg",
      icoUrl: "/static/images/hangzhi/default.ico",
      siderLogo: "/static/images/hangzhi/siderLogo.png"
    },
    'opr-kks.51xinlong.com': {
      ename: "oprkankanshui",
      title: "侃侃税",
      domain: "opr-kks.51xinlong.com",
      logo: "/static/images/kks/logo.png",
      logoTop: "",
      logoLogin: "/static/images/kks/logo.png",
      backgroundImg: "/static/images/kks/banner.jpg",
      icoUrl: "/static/images/kks/default.ico",
      siderLogo: "/static/images/kks/siderLogo.png"
    },
    'opr-xrrl.51xinlong.com': {
      ename: "oprxinrui",
      title: "鑫睿",
      domain: "opr-xrrl.51xinlong.com",
      logo: "/static/images/xrr/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xrr/logo.png",
      backgroundImg: "/static/images/xrr/banner.jpg",
      icoUrl: "/static/images/xrr/default.ico",
      siderLogo: "/static/images/xrr/siderLogo.png"
    },
    'opr-xl.51xinlong.com': {
      ename: "oprxinlian",
      title: "薪联",
      domain: "opr-xl.51xinlong.com",
      logo: "/static/images/xlx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xlx/logo.png",
      backgroundImg: "/static/images/xlx/banner.jpg",
      icoUrl: "/static/images/xlx/default.ico",
      siderLogo: "/static/images/xlx/siderLogo.png"
    },
    'opr-yzn.51xinlong.com': {
      ename: "opryuzhineng",
      title: "育之能",
      domain: "opr-yzn.51xinlong.com",
      logo: "/static/images/yzn/logo.png",
      logoTop: "",
      logoLogin: "/static/images/yzn/logo.png",
      backgroundImg: "/static/images/yzn/banner.jpg",
      icoUrl: "/static/images/yzn/default.ico",
      siderLogo: "/static/images/yzn/siderLogo.png"
    },
    'opr-kfx.51xinlong.com': {
      ename: "oprkuaifaxin",
      title: "快发薪",
      domain: "opr-kfx.51xinlong.com",
      logo: "/static/images/kfx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/kfx/logo.png",
      backgroundImg: "/static/images/kfx/banner.jpg",
      icoUrl: "/static/images/kfx/default.ico",
      siderLogo: "/static/images/kfx/siderLogo.png"
    },
    'opr-xdx.51xinlong.com': {
      ename: "oprxindongxiang",
      title: "薪动象",
      domain: "opr-xdx.51xinlong.com",
      logo: "/static/images/xdx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xdx/logo.png",
      backgroundImg: "/static/images/xdx/banner.jpg",
      icoUrl: "/static/images/xdx/default.ico",
      siderLogo: "/static/images/xdx/siderLogo.png"
    },
    'opr.kaiyuanstaff.com': {
      ename: "oprkaiyuan",
      title: "开源",
      domain: "opr.kaiyuanstaff.com",
      logo: "/static/images/kylogo.png",
      logoTop: "",
      logoLogin: "/static/images/ky/logo.png",
      backgroundImg: "/static/images/ky/banner.jpg",
      icoUrl: "/static/images/ky/default.ico",
      siderLogo: "/static/images/ky/siderLogo.png"
    },
    'opr-qfwl.51xinlong.com': {
      ename: "oprqunfengwangluo",
      title: "群蜂网络",
      domain: "opr-qfwl.51xinlong.com",
      logo: "/static/qfwl/kylogo.png",
      logoTop: "",
      logoLogin: "/static/images/qfwl/logo.png",
      backgroundImg: "/static/images/qfwl/banner.jpg",
      icoUrl: "/static/images/qfwl/default.ico",
      siderLogo: "/static/images/qfwl/siderLogo.png"
    },
    'opr.91hyr.cn': {
      ename: "oprhuiyongren",
      title: "惠用人",
      domain: "opr.91hyr.cn",
      logo: "/static/hyr/kylogo.png",
      logoTop: "",
      logoLogin: "/static/images/hyr/logo.png",
      backgroundImg: "/static/images/hyr/banner.jpg",
      icoUrl: "/static/images/hyr/default.ico",
      siderLogo: "/static/images/hyr/siderLogo.png"
    },
     'opr.hudarenzi.com': {
     ename: "oprhudarenzi",
     title: "沪达人资",
     domain: "opr.hudarenzi.com", 
     logo: "/static/hdrz/kylogo.png",
     logoTop: "",
     logoLogin: "/static/images/hdrz/logo.png",
     backgroundImg: "/static/images/hdrz/banner.jpg",
     icoUrl: "/static/images/hdrz/default.ico",
     siderLogo: "/static/images/hdrz/siderLogo.png"
     },
     'opr-hfx.51xinlong.com': {
     ename: "oprlinggongling",
     title: "灵工灵",
     domain: "opr-hfx.51xinlong.com", 
     logo: "/static/szx/kylogo.png",
     logoTop: "",
     logoLogin: "/static/images/szx/logo.png",
     backgroundImg: "/static/images/szx/banner.jpg",
     icoUrl: "/static/images/szx/default.ico",
     siderLogo: "/static/images/szx/siderLogo.png"
     },
     'opr.renheweilai.cn': {
     ename: "oprrenweiwang",
     title: "人为网",
     domain: "opr.renheweilai.cn",
     logo: "/static/images/rww/logo.png",
     logoTop: "",
     logoLogin: "/static/images/rww/logo.png",
     backgroundImg: "/static/images/rww/banner.jpg",
     icoUrl: "/static/images/rww/default.ico",
     siderLogo: "/static/images/rww/siderLogo.png" 
     },
     'opr-glrl.51xinlong.com': { 
     ename: "oprguoqingrenli",
     title: "国勤人力",
     domain: "opr-glrl.51xinlong.com",
     logo: "/static/images/szx/logo.png", 
     logoTop: "",
     logoLogin: "/static/images/szx/logo.png",
     backgroundImg: "/static/images/szx/banner.jpg",
     icoUrl: "/static/images/szx/default.ico",
     siderLogo: "/static/images/szx/siderLogo.png" 
     },
     'opr-sst.51xinlong.com': {
     ename: "oprshunxiangtong",
     title: "顺享通",
     domain: "opr-sst.51xinlong.com",
     logo: "/static/images/sxt/logo.png",
     logoTop: "",
     logoLogin: "/static/images/sxt/logo.png",
     backgroundImg: "/static/images/sxt/banner.jpg",
     icoUrl: "/static/images/sxt/default.ico",
     siderLogo: "/static/images/sxt/siderLogo.png"
  },
     'opr-sxt.51xinlong.com': {
     ename: "oprshunxiangtongmyself",
     title: "顺享通",
     domain: "opr-sxt.51xinlong.com",
     logo: "/static/images/sxt/logo.png",
     logoTop: "",
     logoLogin: "/static/images/sxt/logo.png",
     backgroundImg: "/static/images/sxt/banner.jpg",
     icoUrl: "/static/images/sxt/default.ico",
     siderLogo: "/static/images/sxt/siderLogo.png"
  },
    'opr-wdycs.51xinlong.com': { 
     ename: "oprwendayuancaishui",
     title: "文达圆财税",
     domain: "opr-wdycs.51xinlong.com",
     logo: "/static/images/wdycs/logo.png",
     logoTop: "",
     logoLogin: "/static/images/wdycs/logo.png",
     backgroundImg: "/static/images/wdycs/banner.jpg",
     icoUrl: "/static/images/wdycs/default.ico",
     siderLogo: "/static/images/wdycs/siderLogo.png"
  },
  'opr-xash.51xinlong.com': {
     ename: "oprxianshanghao",
     title: "西安商皓",
     domain: "opr-xash.51xinlong.com", 
     logo: "/static/images/xash/logo.png",
     logoTop: "",
     logoLogin: "/static/images/xash/logo.png",
     backgroundImg: "/static/images/xash/banner.jpg",
     icoUrl: "/static/images/xash/default.ico",
     siderLogo: "/static/images/xash/siderLogo.png"
  },
  'opr-sjl.51xinlong.com': {
     ename: "oprshuijiling",
     title: "水吉灵",
     domain: "opr-sjl.51xinlong.com", 
     logo: "/static/images/sjl/logo.png",
     logoTop: "",
     logoLogin: "/static/images/sjl/logo.png",
     backgroundImg: "/static/images/sjl/banner.jpg",
     icoUrl: "/static/images/sjl/default.ico",
     siderLogo: "/static/images/sjl/siderLogo.png"
  },
  'opr-fhcs.51xinlong.com': {
    ename: "oprfuhecaishui",
    title: "富合财税",
    domain: "opr-fhcs.51xinlong.com", 
    logo: "/static/images/fhcs/logo.png",
    logoTop: "",
    logoLogin: "/static/images/fhcs/logo.png",
    backgroundImg: "/static/images/fhcs/banner.jpg",
    icoUrl: "/static/images/fhcs/default.ico",
    siderLogo: "/static/images/fhcs/siderLogo.png"
 },
 'opr-yzs.51xinlong.com': {
  ename: "oprshancaiqifu",
  title: "善财企服",
  domain: "opr-yzs.51xinlong.com", 
  logo: "/static/images/scqf/logo.png",
  logoTop: "",
  logoLogin: "/static/images/scqf/logo.png",
  backgroundImg: "/static/images/scqf/banner.jpg",
  icoUrl: "/static/images/scqf/default.ico",
  siderLogo: "/static/images/scqf/siderLogo.png"
},
'opr-xxrl.51xinlong.com': {
  ename: "oprxingxinrenli",
  title: "兴信人力",
  domain: "opr-xxrl.51xinlong.com", 
  logo: "/static/images/xxrl/logo.png",
  logoTop: "",
  logoLogin: "/static/images/xxrl/logo.png",
  backgroundImg: "/static/images/xxrl/banner.jpg",
  icoUrl: "/static/images/xxrl/default.ico",
  siderLogo: "/static/images/xxrl/siderLogo.png"
},
'opr-lblg.51xinlong.com': {
  ename: "oprlianbeilinggong",
  title: "联贝灵工",
  domain: "opr-lblg.51xinlong.com", 
  logo: "/static/images/lblg/logo.png",
  logoTop: "",
  logoLogin: "/static/images/lblg/logo.png",
  backgroundImg: "/static/images/lblg/banner.jpg",
  icoUrl: "/static/images/lblg/default.ico",
  siderLogo: "/static/images/lblg/siderLogo.png"
},
'www.yifx.vip': {
  ename: "opryifuxin",
  title: "易付薪",
  domain: "www.yifx.vip", 
  logo: "/static/images/yfx/logo.png",
  logoTop: "",
  logoLogin: "/static/images/yfx/logo.png",
  backgroundImg: "/static/images/yfx/banners.jpg",
  icoUrl: "/static/images/yfx/default.ico",
  siderLogo: "/static/images/yfx/siderLogo.png?a=1"
},
'opr.yifx.vip': {
  ename: "opryifuxing",
  title: "易付薪",
  domain: "opr.yifx.vip", 
  logo: "/static/images/yfx/logo.png",
  logoTop: "",
  logoLogin: "/static/images/yfx/logo.png",
  backgroundImg: "/static/images/yfx/banners.jpg",
  icoUrl: "/static/images/yfx/default.ico",
  siderLogo: "/static/images/yfx/siderLogo.png?a=1"
},
'opr.jinshuishuke.com': {
  ename: "oprjinshuishuke",
  title: "金税数科",
  domain: "opr.jinshuishuke.com", 
  logo: "/static/images/jssk/logo.png",
  logoTop: "",
  logoLogin: "/static/images/jssk/logo.png",
  backgroundImg: "/static/images/jssk/banner.jpg",
  icoUrl: "/static/images/jssk/default.ico",
  siderLogo: "/static/images/jssk/siderLogo.png"
},
'opr-qch.51xinlong.com': {
  ename: "oprqicaihui",
  title: "企才惠",
  domain: "opr-qch.51xinlong.com", 
  logo: "/static/images/szx/logo.png",
  logoTop: "",
  logoLogin: "/static/images/szx/logo.png",
  backgroundImg: "/static/images/szx/banner.jpg",
  icoUrl: "/static/images/szx/default.ico",
  siderLogo: "/static/images/szx/siderLogo.png"
},
'opr-ycyy.51xinlong.com': {
  ename: "opryingchuang",
  title: "赢创",
  domain: "opr-ycyy.51xinlong.com", 
  logo: "/static/images/yc/logo.png",
  logoTop: "",
  logoLogin: "/static/images/yc/logo.png",
  backgroundImg: "/static/images/yc/banner.jpg",
  icoUrl: "/static/images/yc/default.ico",
  siderLogo: "/static/images/yc/siderLogo.png"
},
'opr.qihaoyunwang.com': {
  ename: "oprqihaoyun",
  title: "企好运",
  domain: "opr.qihaoyunwang.com", 
  logo: "/static/images/qhy/logo.png",
  logoTop: "",
  logoLogin: "/static/images/qhy/logo.png",
  backgroundImg: "/static/images/qhy/banner.jpg",
  icoUrl: "/static/images/qhy/default.ico",
  siderLogo: "/static/images/qhy/siderLogo.png"
},
'opr.jyuan.net': {
  ename: "opryunqi",
  title: "云企",
  domain: "opr.jyuan.net", 
  logo: "/static/images/szx/logo.png",
  logoTop: "",
  logoLogin: "/static/images/szx/logo.png",
  backgroundImg: "/static/images/szx/banner.jpg",
  icoUrl: "/static/images/szx/default.ico",
  siderLogo: "/static/images/szx/siderLogo.png"
    },
    'opr-bgkj.51xinlong.com': {
    ename: "oprbaogukeji",
    title: "包谷科技",
    domain: "opr-bgkj.51xinlong.com", 
    logo: "/static/images/bgkj/logo.png",
    logoTop: "",
    logoLogin: "/static/images/bgkj/logo.png",
    backgroundImg: "/static/images/bgkj/banner.jpg",
    icoUrl: "/static/images/bgkj/default.ico",
    siderLogo: "/static/images/bgkj/siderLogo.png"
    },
    'opr-lxy.51xinlong.com': {
      ename: "oprlingxinyi",
      title: "灵薪易",
      domain: "opr-lxy.51xinlong.com", 
      logo: "/static/images/lxy/logo.png",
      logoTop: "",
      logoLogin: "/static/images/lxy/logo.png",
      backgroundImg: "/static/images/lxy/banner.jpg",
      icoUrl: "/static/images/lxy/default.ico",
      siderLogo: "/static/images/lxy/siderLogo.png"
      },
      'opr-phw.51xinlong.com': {
        ename: "oprpenghuwan",
        title: "澎湖湾",
        domain: "opr-phw.51xinlong.com", 
        logo: "/static/images/szx/logo.png",
        logoTop: "",
        logoLogin: "/static/images/szx/logo.png",
        backgroundImg: "/static/images/szx/banner.jpg",
        icoUrl: "/static/images/szx/default.ico",
        siderLogo: "/static/images/szx/siderLogo.png"
    },
    'opr-xxh.51xinlong.com': {
      ename: "oprxinxinhang",
      title: "薪新航",
      domain: "opr-xxh.51xinlong.com", 
      logo: "/static/images/xxh/logo.png",
      logoTop: "",
      logoLogin: "/static/images/xxh/logo.png",
      backgroundImg: "/static/images/xxh/banner.jpg",
      icoUrl: "/static/images/xxh/default.ico",
      siderLogo: "/static/images/xxh/siderLogo.png"
    },
    'opr-zyt.51xinlong.com': {
      ename: "oprzhanyoutan",
      title: "绽优昙",
      domain: "opr-zyt.51xinlong.com", 
      logo: "/static/images/zyt/logo.png",
      logoTop: "",
      logoLogin: "/static/images/zyt/logo.png",
      backgroundImg: "/static/images/zyt/banner.jpg",
      icoUrl: "/static/images/zyt/default.ico",
      siderLogo: "/static/images/zyt/siderLogo.png"
    },
    'opr-gll.51xinlong.com': {
      ename: "oprganlanlv",
      title: "橄榄绿",
      domain: "opr-gll.51xinlong.com", 
      logo: "/static/images/gll/logo.png",
      logoTop: "",
      logoLogin: "/static/images/gll/logo.png",
      backgroundImg: "/static/images/gll/banner.jpg",
      icoUrl: "/static/images/gll/default.ico",
      siderLogo: "/static/images/gll/siderLogo.png"
    },
    'oprjiufx.51xinlong.com': {
      ename: "oprjiufenxiang",
      title: "酒分享",
      domain: "oprjiufx.51xinlong.com", 
      logo: "/static/images/jfx/logo.png",
      logoTop: "",
      logoLogin: "/static/images/jfx/logo.png",
      backgroundImg: "/static/images/jfx/banner.jpg",
      icoUrl: "/static/images/jfx/default.ico",
      siderLogo: "/static/images/jfx/siderLogo.png"
      }

  }
}

let hostname =window.location.hostname
// hostname ='www.testaaa.com'
//同步请求
function sync_test(url, data) {
	//实例化XmlHttpRequest对象
	var xhr = new XMLHttpRequest();
	//使用GET方式请求指定网址的页面
	
	xhr.open("GET", process.env.VUE_APP_AXIOS_BASE_URL + url, false);
	xhr.setRequestHeader("DOMAIN",data);  //设置请求头
	//发送空内容请求
	xhr.send();

	if (xhr.status === 200) { //200状态码表示正常     
		return JSON.parse(xhr.responseText)?.data || ''
	} else {
		console.log(xhr.statusText)
	}
}
//获取oem
let res = sync_test('/paas/oem/view', hostname)

if (res.status || Object.keys(config.initDomain).includes(hostname)) {
	config.domain =res.data|| Object.assign(config.initDomain.default,config.initDomain[hostname])
} else {
	config.domain = config.initDomain.default
}
store.commit('handleDomainInfo', config.domain)
export default config
